import { takeLatest, put, call } from "redux-saga/effects";
import { requestDefaultJson } from "./helpers";
import getEnvParam from "../../utils/getEnvParam";
import { Creators as actionAuthorization } from '../ducks/authorization'
import { Creators as actionAutentication } from '../ducks/authentication'
import log from "loglevel";
import jwt_decode from 'jwt-decode';

function getAuthorizationFromApi(id) {
    return requestDefaultJson({
        method: "POST",
        URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/auth/gettoken',
        headers: {
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_LOGIN"),
        },
        data: {
            chave: id
        },
    }, 
    undefined, 
    undefined, 
    undefined, 
    (resolve, reject) => error => { reject(error.response.data); log.info(error); });
}

//generators
function* getAuthorizationAsync(payload) {
    const { id } = payload;
    try {
        yield put(actionAutentication.loginLoading());

        let { perfis, token, chapa, nome } = yield call(getAuthorizationFromApi, id);
        yield put({ type: "CHAPA", chapa: chapa });

        if (isFirstLogin(token)) {
            yield put(actionAuthorization.authorization(perfis.split(',')));
            yield put(actionAutentication.loginRegister(chapa, token));
        } else if (perfis && token) {
            yield put(actionAuthorization.authorization(perfis.split(',')));
            var context = decodeTokenJwt(token);
            context.nome = nome;
            yield put(actionAutentication.loginSuccess(token, context));
        }

    } catch (error) {
        yield put(actionAutentication.loginUnauthorized());
        log.info(error);
    }
}

function isFirstLogin(token) {
    if (!token || token === 'null') {
        return true;
    }
    var context = decodeTokenJwt(token);
    
    if (!context.idFornecedor && 
        !context.idCd && 
        !context.idEmpresa && 
        context.admin === '0') {
        return true;
    }
    return false;
}

export function decodeTokenJwt(token) {
    var credenciais = jwt_decode(token)
    if (!credenciais || !credenciais.sub) {
        return null;
    }
    var context = {}
    credenciais.sub.split(';').forEach(element => {
        var item = element.split(',')
        if (item.length === 2) {
            context[item[0]] = item[1] === 'null' ? null : item[1]
        } 
    });
    return context
}

// //Generator function
export function* getAuthorizationWatcher() {
    yield takeLatest("GET_AUTHORIZATION", getAuthorizationAsync);
}
